import React from 'react'

function SingleModel() {
  return (
    <div>SingleModel</div>
  )
}

export default SingleModel